export default __webpack_public_path__ + "static/media/pp-7.869f4ce4.svg";